import { Navigate } from 'react-router'
import { ActivityTable } from '@/components/activity/ActivityTable'
import { PageHeader } from '@/components/PageHeader'
import { ErrorState, LoadingState } from '@/components/PageState'
import { useDashboardScope } from '@/dashboard/DashboardScope'
import { ReadOnlyBanner } from '@/dashboard/ReadOnlyBanner'
import { apiErrorMessage } from '@/helpers/apiErrorMessage'
import { useTenantActivity } from '@/hooks/useTeam'

/**
 * The organization's activity log (owners): team changes, profile and status
 * changes, and every time PixelSign staff viewed the dashboard.
 */
export function ActivityPage() {
  const scope = useDashboardScope()
  const query = useTenantActivity(scope.role === 'owner')

  function renderBody() {
    if (query.isLoading) return <LoadingState />
    if (query.isError || !query.data) {
      return <ErrorState message={apiErrorMessage(query.error, 'Could not load activity.')} />
    }
    return <ActivityTable events={query.data.events} />
  }

  if (scope.role !== 'owner') return <Navigate to={`${scope.basePath}/team`} replace />

  return (
    <>
      <PageHeader title="Activity" description={`Changes to ${scope.tenantName}'s team and settings, newest first.`} />
      <ReadOnlyBanner />
      {renderBody()}
    </>
  )
}
